// extracted by mini-css-extract-plugin
export var modal = "_sp-0";
export var table = "_sp-1";